export interface IOrgMileageWizardInfo {
  orgId: number;
  userId: string;
  modeOfJourney: number;
  rateType: number;
  isPayActualEnabled: boolean;
  isDetourIncludedInDistance: boolean;
  triangulationRule: number;
  isGoogleMappingEnabled: boolean;
  isDetourEnabled: boolean;
  mileageUOM: number;
  action:number;
  limitChar:number;
  isGoogleCallsRestrict: boolean;
  notesForGoogle:string;
  isPassengerPayEnabled:boolean;
  trialMileageHideDate:number;
  subscriptionStartDate:number;
}

export class OrgMileageWizardInfo implements IOrgMileageWizardInfo {
  orgId: number;
  userId: string;
  modeOfJourney: number;
  rateType: number;
  isPayActualEnabled: boolean;
  isDetourIncludedInDistance: boolean;
  triangulationRule: number;
  isGoogleMappingEnabled: boolean;
  isDetourEnabled: boolean;
  mileageUOM: number;
  action:number;
  limitChar:number;
  isGoogleCallsRestrict: boolean;
  notesForGoogle:string = '';
  isPassengerPayEnabled:boolean
  trialMileageHideDate:number;
  subscriptionStartDate:number;
}

export interface IOrgRequestDto {
  orgId: string;
}


export class OrgRequestDto implements IOrgRequestDto {
  orgId: string;

  constructor(orgId: string) {
    this.orgId = orgId;
  }
}

export interface IReqVehicleExpenseCounter {
  userVehicleIds: number[];
  action: number;
}

export class ReqVehicleExpenseCounter implements IReqVehicleExpenseCounter {
  userVehicleIds: number[];
  action: number;
}

export interface IRespVehicleExpenseCounter {
  vehicleExpenseCounter: IVehicleExpenseCounter[];
}

export class RespVehicleExpenseCounter implements IRespVehicleExpenseCounter {
  vehicleExpenseCounter: IVehicleExpenseCounter[];
}

export interface IVehicleExpenseCounter {
  vehicleId: number;
  expenseCount: number;
  milesDone: number;
}

export class VehicleExpenseCounter implements IVehicleExpenseCounter {
  vehicleId: number;
  expenseCount: number;
  milesDone: number;
}

export interface IAddUpdateUserVehicleRequest {
  userVehicleSetupList: IUserVehicleDTO[];
  mileageAllowanceList: IMileageAllowanceDTO[];
  mileageAllowanceMapping: IMileageAllowanceMappingDTO[];
  allowanceIds: number[];
  orgVehicleTypeMapId: number;
  purchaseFunctionList: number[];
  action: number;
  employeeId: number;
  isFMAction: boolean;
  isOpeningBalanceEdited:boolean;
}

export class AddUpdateUserVehicleRequest implements IAddUpdateUserVehicleRequest {
  userVehicleSetupList: IUserVehicleDTO[];
  mileageAllowanceList: IMileageAllowanceDTO[];
  mileageAllowanceMapping: IMileageAllowanceMappingDTO[];
  allowanceIds: number[];
  orgVehicleTypeMapId: number;
  purchaseFunctionList: number[];
  action: number;
  isFMAction: boolean;
  employeeId: number;
  isOpeningBalanceEdited:boolean = false;
}

export interface IMileageAllowanceMappingDTO {
  mileageAllowanceMappingId: number;
  allowanceId: number;
  orgVehicleTypeMapId: number;
  orgId: number;
}

export class MileageAllowanceMappingDTO implements IMileageAllowanceMappingDTO {
  mileageAllowanceMappingId: number;
  allowanceId: number;
  orgVehicleTypeMapId: number;
  orgId: number;
  constructor(mileageAllowanceMappingId: number,
    allowanceId: number,
    orgVehicleTypeMapId: number,
    orgId: number) {
    this.mileageAllowanceMappingId = mileageAllowanceMappingId;
    this.allowanceId = allowanceId;
    this.orgVehicleTypeMapId = orgVehicleTypeMapId;
    this.orgId = orgId;
  }
}

export interface IMileageAllowanceDTO {
  mileageAllowanceId: number;
  defaultAllowanceRate: number;
  allowanceRate: number;
  passengerCount: number;
  loadCount: number;
  allowanceDescription: string;
  allowanceIcon: string;
  allowanceId: number;
}

export class MileageAllowanceDTO implements IMileageAllowanceDTO {
  mileageAllowanceId: number;
  defaultAllowanceRate: number;
  allowanceRate: number;
  passengerCount: number;
  loadCount: number;
  allowanceDescription: string;
  allowanceIcon: string;
  allowanceId: number;
  constructor(mileageAllowanceId: number,
    defaultAllowanceRate: number,
    allowanceRate: number,
    passengerCount: number,
    loadCount: number,
    allowanceDescription: string,
    allowanceIcon: string,
    allowanceId: number) {
    this.mileageAllowanceId = mileageAllowanceId;
    this.defaultAllowanceRate = defaultAllowanceRate;
    this.allowanceRate = allowanceRate;
    this.passengerCount = passengerCount;
    this.loadCount = loadCount;
    this.allowanceDescription = allowanceDescription;
    this.allowanceIcon = allowanceIcon;
    this.allowanceId = allowanceId;
  }
}

export interface IUserVehicleDTO {
  userId: number;
  orgId: number;
  vehicleTypeId: number;
  vehicleStatus: number;
  vehicleSubTypeId: number;
  rateType: number;
  orgVehicleTypeMapId: number;
  averageMiles: number;
  openingBalance: number;
  milesDone: number;
  isPreferred: boolean;
  derivedName: string;
  vehicleId: number;
  registrationNumber: string;
  makeModel: string;
  oldVehicleStatus: number;
}

export class UserVehicleDTO implements IUserVehicleDTO {
  userId: number;
  orgId: number;
  vehicleTypeId: number;
  vehicleStatus: number;
  vehicleSubTypeId: number;
  rateType: number;
  orgVehicleTypeMapId: number;
  averageMiles: number = 0;
  openingBalance: number = 0;
  milesDone: number = 0;
  isPreferred: boolean;
  derivedName: string;
  vehicleId: number;
  registrationNumber: string;
  makeModel: string;
  oldVehicleStatus: number;
  isChangeVehicle:boolean;
  constructor(userId: number,
    orgId: number,
    vehicleTypeId: number,
    vehicleStatus: number,
    vehicleSubTypeId: number,
    rateType: number,
    orgVehicleTypeMapId: number,
    isPreferred: boolean,
    derivedName: string,
    averageMiles: number,
    openingBalance: number,
    milesDone: number,
    vehicleId: number,
    registrationNumber: string,
    makeModel: string,
    oldVehicleStatus: number,isChangeVehicle:boolean) {
    this.userId = userId;
    this.orgId = orgId;
    this.vehicleTypeId = vehicleTypeId;
    this.vehicleSubTypeId = vehicleSubTypeId;
    this.vehicleStatus = vehicleStatus;
    this.orgVehicleTypeMapId = orgVehicleTypeMapId;
    this.isPreferred = isPreferred;
    this.rateType = rateType;
    this.derivedName = derivedName;
    this.averageMiles = averageMiles;
    this.openingBalance = openingBalance;
    this.milesDone = milesDone;
    this.vehicleId = vehicleId;
    this.registrationNumber = registrationNumber;
    this.makeModel = makeModel;
    this.oldVehicleStatus = oldVehicleStatus;
    this.isChangeVehicle = isChangeVehicle;
  }
}

export class OrgMileagePreferencesDetail {
  IsPolicyOnVehicleChange: boolean;
}
export class MileageRateDetail {
  rateHeading: any;
  rateIconClass: any;
  rateHeadingDesc: any;
  knowMoreLink: any;
  btnText: any;
  btnClass: any;
  btnIconClass: any;
  btnClickDetail: any;
  knowMoreText: any;
  divClass: any;
  sequence: number;
  isRateSelected: boolean;
}
